import styled, { keyframes } from "styled-components";

export const Checkbox = styled("div")``;

export const Input = styled("input")`
  display: none;

  &:not(:disabled) {
    &:focus ~ label,
    &:active ~ label {
      background: transparent;
    }

    &:checked ~ label {
      color: white;
      background-color: ${({ theme }) => theme.colors.Primary};
      border: 1px solid ${({ theme }) => theme.colors.Primary};
    }
  }

  &:disabled {
    & ~ label {
    }
  }
`;

export const OptionLabel = styled("label")`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: rgba(0, 0, 24, 0.84);
  line-height: 16px;
  z-index: 2;
  padding: 0px 7px;
  border-radius: 3px;
  border: 1px solid rgba(210, 210, 210, 1);
  font-size: 12px;
  transition: all 0.3s ease, transform 0.3s ease;
`;
